// @flow
import { createReducer } from "reduxsauce";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  searchResult: null,
  isListing: false
};

/* Generic error message */
const genericError = "Something went wrong";

/* Get requests */
export const searchDisputeAsnRtv = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isListing: true
  };
};

export const searchDisputeAsnRtvSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  searchResult: action.searchResult,
  isListing: false
});

export const searchDisputeAsnRtvFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isListing: false,
  errorMessage: action.error || genericError
});

/* listDisputeReasons */
export const listDisputeReasons = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isListing: true
  };
};

export const listDisputeReasonsSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  disputeReasons: action.disputeReasons,
  isListing: false
});

export const listDisputeReasonsFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isListing: false,
  errorMessage: action.error || genericError
});

/* Get requests */
export const listDisputes = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: true
  };
};

export const listDisputesSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  disputes: action.disputes,
  isLoading: false
});

export const listDisputesFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

/*createDispute */
export const createDispute = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isCreating: true
  };
};

export const createDisputeSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  disputeNr: action.disputeNr,
  isCreating: false
});

export const createDisputeFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isCreating: false,
  errorMessage: action.error || genericError
});

const ACTION_HANDLERS = {
  [Types.SEARCH_DISPUTE_ASN_RTV]: searchDisputeAsnRtv,
  [Types.SEARCH_DISPUTE_ASN_RTV_SUCCESS]: searchDisputeAsnRtvSuccess,
  [Types.SEARCH_DISPUTE_ASN_RTV_FAILURE]: searchDisputeAsnRtvFailure,
  [Types.CREATE_DISPUTE]: createDispute,
  [Types.CREATE_DISPUTE_SUCCESS]: createDisputeSuccess,
  [Types.CREATE_DISPUTE_FAILURE]: createDisputeFailure,
  [Types.LIST_DISPUTES]: listDisputes,
  [Types.LIST_DISPUTES_SUCCESS]: listDisputesSuccess,
  [Types.LIST_DISPUTES_FAILURE]: listDisputesFailure,
  [Types.LIST_DISPUTE_REASONS]: listDisputeReasons,
  [Types.LIST_DISPUTE_REASONS_SUCCESS]: listDisputeReasonsSuccess,
  [Types.LIST_DISPUTE_REASONS_FAILURE]: listDisputeReasonsFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/DisputesReducer.js